export default __webpack_public_path__ + "static/media/calendar.7b954277.svg";